export const mergeConfig = (defaults, user) => {
    if (!user) return { ...defaults };

    // 1. Copy Defaults
    // 2. Spread User Data ON TOP (User arrays like sections/articles win 100% of the time)
    const merged = { ...defaults, ...user };

    // 3. Deep Merge specific setting objects to ensure new styling keys exist
    if (user.settings) {
        merged.settings = { ...defaults.settings, ...user.settings };
        // SECURITY CHECK: Ensure navLinks is an array
        if (!merged.settings.navLinks) merged.settings.navLinks = [...defaults.settings.navLinks];
    }
    if (user.typography) merged.typography = { ...defaults.typography, ...user.typography };

    // 4. Hero Button Migration
    if (user.hero) {
        merged.hero = { ...defaults.hero, ...user.hero };
        if (user.hero.buttonText && (!user.hero.buttons || user.hero.buttons.length === 0)) {
            merged.hero.buttons = [{ text: user.hero.buttonText, link: "#", variant: "primary" }];
        }
    }

    // 5. Ensure sections and columns have stable IDs
    if (merged.sections) {
        merged.sections = merged.sections.map((s, si) => {
            if (!s.id) s.id = `s-${Date.now()}-${si}`;
            if (s.columns) {
                s.columns = s.columns.map((c, ci) => {
                    if (!c.id) c.id = `col-${Date.now()}-${si}-${ci}`;
                    return c;
                });
            }
            return s;
        });
    }

    // 6. Safeguards against null arrays
    if (!merged.articles || !Array.isArray(merged.articles)) merged.articles = [];
    if (!merged.pages || !Array.isArray(merged.pages)) merged.pages = [];
    else {
        merged.pages = merged.pages.map((p, pi) => {
            if (!p.id) p.id = Date.now() + pi;
            if (!p.hero || typeof p.hero !== 'object') {
                p.hero = {
                    title: p.title || "Custom Page",
                    subtitle: "Customize this subtitle...",
                    buttons: [],
                    backgroundColor: "#2a0a0a",
                    textColor: "#ffffff",
                    backgroundImage: p.image || "",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    foregroundImage: "",
                    imageWidth: "300px"
                };
            }
            if (!p.sections || !Array.isArray(p.sections)) {
                if (p.content) {
                    p.sections = [
                        {
                            id: `s-migrated-${Date.now()}-${pi}`,
                            title: "Main Content",
                            backgroundColor: "#ffffff",
                            backgroundImage: "",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            minHeight: "auto",
                            padding: "4rem 2rem",
                            heading: "",
                            subHeading: "",
                            foregroundImage: "",
                            columns: [
                                {
                                    id: `col-migrated-${Date.now()}-${pi}`,
                                    heading: "",
                                    text: p.content,
                                    width: 12
                                }
                            ]
                        }
                    ];
                } else {
                    p.sections = [];
                }
            }
            p.sections = p.sections.map((s, si) => {
                if (!s.id) s.id = `s-page-${Date.now()}-${si}`;
                if (s.columns) {
                    s.columns = s.columns.map((c, ci) => {
                        if (!c.id) c.id = `col-page-${Date.now()}-${si}-${ci}`;
                        return c;
                    });
                }
                return s;
            });
            return p;
        });
    }
    if (!merged.footer || !Array.isArray(merged.footer)) merged.footer = [];
    if (!merged.socials || !Array.isArray(merged.socials)) merged.socials = [];
    if (!merged.customFonts || !Array.isArray(merged.customFonts)) merged.customFonts = Array.isArray(user?.customFonts) ? user.customFonts : [];

    return merged;
};
